import './index.scss'
import {GlobalOutlined, MenuOutlined, SettingOutlined, SunOutlined} from "@ant-design/icons";
import {Button, Dropdown, Flex, Grid, Switch} from "antd";
import {Header} from "antd/es/layout/layout";
import {useDispatch, useSelector} from "react-redux";
import {changeThemeMode} from "../../store/slice/themeSlice";
import {toggleDoubleClickConfirm} from "../../store/slice/settingsSlice";
import {authData} from "../../store/slice/authSlice";
import {useNavigate} from "react-router-dom";
import {BsMoon} from "react-icons/bs";
import i18n from 'i18next';
import {useTranslation} from 'react-i18next';
import {MdExitToApp} from "react-icons/md";

const AppHeader = ({showMenuButton = false, onMenuClick}) => {
    const screens = Grid.useBreakpoint()
    const isMobile = screens.md === false
    const {systemMode}=useSelector(state => state.theme)
    const {doubleClickConfirm}=useSelector(state => state.settings)
    const {data:{user}}=useSelector(state => state.auth)
    const {t} = useTranslation();
    const dispatch=useDispatch()
    const navigate=useNavigate()

    const logOut =() => {
        localStorage.removeItem('token')
        localStorage.removeItem('refToken')
        dispatch(authData({
            user: null,
            isLoading: false,
            isAuthenticated: false
        }))
        navigate('/login')
    }
    const isDarkHandle=()=>{
        dispatch(changeThemeMode())
    }

    const languageItems = [
        {
            key: 'uz',
            label: t('uzbek_latin'),
            onClick: () => i18n.changeLanguage('uz')
        },
        {
            key: 'uz_cyrl',
            label: t('uzbek_cyrillic'),
            onClick: () => i18n.changeLanguage('kr')
        },
        {
            key: 'ru',
            label: t('russian'),
            onClick: () => i18n.changeLanguage('ru')
        }
    ];

    const settingsItems = [
        {
            key: 'doubleClickConfirm',
            label: (
                <Flex align={"center"} justify={"space-between"} gap={16} style={{minWidth: "min(260px, 70vw)"}}>
                    <span>{t('double_click_confirm')}</span>
                    <Switch
                        size={"small"}
                        checked={doubleClickConfirm}
                        onChange={() => dispatch(toggleDoubleClickConfirm())}
                    />
                </Flex>
            )
        }
    ];

    const menuIcon = <MenuOutlined className={'icon'} style={{fontSize:16}}/>
    const themeIcon = systemMode==='light'?
        <BsMoon className={'icon'} style={{fontSize:16}} />:
        <SunOutlined className={'icon'} style={{fontSize:16}}/>
    const languageIcon = <GlobalOutlined className={'icon'} style={{fontSize:16}}/>
    const settingsIcon = <SettingOutlined className={'icon'} style={{fontSize:16}}/>

    // On phones the icon goes through the `icon` prop so antd renders a compact 32px square button;
    // as children it keeps the 15px side padding (48px wide) and the header overflows on narrow screens.
    return (
        <Header className={'app-header'}>
            <Flex align={"center"} gap={isMobile ? 6 : 10}>
                {showMenuButton && (
                    isMobile
                        ? <Button onClick={onMenuClick} aria-label="menu" icon={menuIcon}/>
                        : <Button onClick={onMenuClick} aria-label="menu">{menuIcon}</Button>
                )}
                <Flex style={isMobile ? {width:64, height:44} : {width:90, height:70}} align={"center"} justify={"center"}>
                    <img className={'logo'}
                         src='/Logo_.png'
                         alt="logo"
                         style={{width:'100%', height:'100%', objectFit: "contain"}}
                    />
                </Flex>
            </Flex>
            <Flex align={"center"} gap={isMobile ? 6 : 10}>
                {isMobile
                    ? <Button onClick={isDarkHandle} icon={themeIcon}/>
                    : <Button onClick={isDarkHandle}>{themeIcon}</Button>}
                <Dropdown menu={{ items: languageItems }} placement="bottomRight">
                    {isMobile
                        ? <Button title={t('language')} icon={languageIcon}/>
                        : <Button title={t('language')}>{t('language')}</Button>}
                </Dropdown>
                <Dropdown menu={{ items: settingsItems }} placement="bottomRight" trigger={['click']}>
                    {isMobile
                        ? <Button title={t('settings')} icon={settingsIcon}/>
                        : <Button title={t('settings')}>{settingsIcon}</Button>}
                </Dropdown>
                <UserAccount user={user} logOut={logOut} isMobile={isMobile} />
            </Flex>
        </Header>
    );
};

export default AppHeader;

export const UserAccount = ({ logOut, isMobile = false}) => {
    const {t} = useTranslation();

    const items = [
        {
            key: '2',
            label: (
                <div onClick={logOut} style={{display:"flex", justifyContent:"center" , alignItems:"center" , width:'100%' , height:'100'}}>
                    <MdExitToApp style={{fontSize:16}} />
                </div>
            ),
        },
    ];

    return(
        <Dropdown menu={{ items }} placement="topRight" className={'userDropdown'}  arrow>
            {isMobile
                ? <Button title={t('logout')} icon={<MdExitToApp style={{fontSize:16}} />}/>
                : <Button title={t('logout')} style={{display:"flex", justifyContent:"center" , alignItems:"center"}}>{t('logout')}</Button>}
        </Dropdown>
    )
}